import { instance } from "apis/interceptor";
import { GLOBAL_MEETING_SETTING_VALUE, MEETING_ALARM_TARGET } from "types/meeting-settings.types";

type ResponseType<T> = {
  success: boolean;
  message: string;
  statusCode?: number;
  data?: T;
};

type TAlarmResponse = {
  success: boolean;
  message?: string;
  data?: TAlarm;
};

export type TAlarm = {
  id: string;
  isNoShowEnabled: GLOBAL_MEETING_SETTING_VALUE;
  hasMeetingRoomUsedTablet: boolean;
  noShowProcessingTime: number;
  isNoShowWarningAlarmEnabled: boolean;
  noShowWarningAlarmTime: number;
  isNoShowProcessingAlarmEnabled: boolean;
  isReminderAlarmEnabled: boolean;
  reminderAlarmTime: number;
  usageConfirmAlarmTime: string;
  usageConfirmAlarmTarget: MEETING_ALARM_TARGET;
  isUsageConfirmAlarmEnabled: boolean;
};

//UPDATE: (new) 알림 설정 조회
export const getAlarm = async (): Promise<TAlarmResponse> => {
  try {
    const res = await instance.get("/meeting-settings/alarm");
    return { success: true, data: res.data };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "권한이 없습니다." };
  }
};

//UPDATE: (new) 노쇼 경고 알림 활성화
export const updateNoShowWarning = async (isNoShowWarningEnabled: boolean): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/no-show-warning", {
      isNoShowWarningAlarmEnabled: isNoShowWarningEnabled,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//UPDATE: (new) 노쇼 처리 알림 활성화
export const updateNoShowProcessing = async (isNoShowProcessingEnabled: boolean): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/no-show-processing", {
      isNoShowProcessingAlarmEnabled: isNoShowProcessingEnabled,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//UPDATE: (new) 예약 일정 시작 전 알림 설정
export const updateMeetingReminder = async (isMeetingReminderEnabled: boolean): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/reminder", {
      isReminderAlarmEnabled: isMeetingReminderEnabled,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//UPDATE: (new) 노쇼 경고 알림 시간 설정
export const updateNoShowWarningTime = async (noShowWarningTime: number): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/no-show-warning/time", {
      noShowWarningAlarmTime: noShowWarningTime,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else if (status === 409) {
      return { success: false, statusCode: 409, message: "" };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//UPDATE: (new) 예약 일정 시작 전 알림 설정
export const updateMeetingReminderTime = async (meetingReminderTime: number): Promise<ResponseType<boolean>> => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/reminder/time", {
      reminderAlarmTime: meetingReminderTime,
    });
    return { success: true, data: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
  }
};

//* INFO: 알림 설정 - 회의실 이용 확인 알림 활성화 수정
export const updateMeetingRoomUsageConfirmAlarm = async (isUsageConfirmAlarmEnabled: boolean) => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/usage-confirm-alarm", {
      isUsageConfirmAlarmEnabled,
    });
    return { success: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else {
      return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
    }
  }
};

//* INFO: 알림 설정 - 회의실 이용 확인 알림 시간 수정
export const updateMeetingRoomUsageConfirmAlarmTime = async (time: string) => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/usage-confirm-alarm/time", {
      usageConfirmAlarmTime: time,
    });
    return { success: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else {
      return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
    }
  }
};

//* INFO: 알림 설정 - 회의실 이용 확인 알림 대상 수정
export const updateMeetingRoomUsageConfirmAlarmTarget = async (target: MEETING_ALARM_TARGET) => {
  try {
    const res = await instance.patch("/meeting-settings/alarm/usage-confirm-alarm/target", {
      usageConfirmAlarmTarget: target,
    });
    return { success: res.data.result, message: "변경사항이 성공적으로 저장되었습니다." };
  } catch (error: any) {
    const status = error.response?.status;
    if (status === 403) {
      return { success: false, message: "권한이 없습니다." };
    } else {
      return { success: false, message: "변경사항 저장 중 오류가 발생했습니다. 다시 시도해 주세요." };
    }
  }
};
